import { useState } from 'react';
import { OverlookEntry } from '../../../shared/types/overlookEntry.ts';
import { NavBar } from '../../components/navBar.tsx';
import { PageTitle } from '../../components/pageTitle.tsx';
import { useEquipmentGrid } from '../../hooks/useEquipmentGrid.ts';
import { useFullScreenToggle } from '../../hooks/useFullscreenToggle.ts';
import { usePageDisplay } from '../../hooks/usePageDisplay.ts';
import { pageDisplayOptions } from '../../types/pageDispalyOptions.ts';
import { trpc } from '../../utils/trpc/trpc.ts';
import { HealthAndControls } from './healthAndControls.tsx';
import { OverlookCell } from './overlookCell.tsx';
import { OverlookStatus } from './overlookStatus.tsx';


export function Overlook() {
    const [pageDisplay, setPageDisplay] = useState(pageDisplayOptions[0]);

    const { data: overlookTable } = trpc.overlook.getTable.useQuery(undefined, {
        refetchInterval: 1_000,
    });

    const { data: diagnosticsResults } = trpc.serverState.getDiagnostics.useQuery(undefined, {
        refetchInterval: 30_000,
    });

    const { isFullscreen } = useFullScreenToggle();
    const { page } = usePageDisplay({ pageDisplay });

    const isSingleView = pageDisplay.key === 'single';
    const grid = useEquipmentGrid({ page, isSingleView });


    return (
        <>
            <PageTitle title='Overlook' />
            {!isFullscreen && <NavBar />}
            <div className='content'>
                {overlookTable == null ? (
                    'Loading...'
                ) : (
                    <div
                        className={`equipment-grid${isSingleView ? ' equipment-grid--single' : ''}`}
                        style={isSingleView ? {
                            gridTemplateColumns: `repeat(${grid.page2ColumnSpan}, minmax(0, 1fr)) 16px repeat(6, minmax(0, 1fr))`,
                        } : undefined}
                    >
                        {isSingleView && <div className='overlook__page-separator' style={{ gridColumn: grid.separatorColumn }} />}

                        {overlookTable?.map((it: OverlookEntry) => {
                            const position = grid.getPosition(it.equipment);
                            if (!position) return null;

                            return (
                                <OverlookCell
                                    key={it.equipment}
                                    style={position}
                                    it={it}
                                />
                            );
                        })}
                        <OverlookStatus
                            overlookTable={overlookTable ?? []}
                            page={page}
                            isSingleView={isSingleView}
                            page1StartColumn={grid.page1StartColumn}
                        />
                        <HealthAndControls
                            diagnosticsData={diagnosticsResults}
                            pageDisplay={pageDisplay}
                            page={page}
                            setPageDisplay={setPageDisplay}
                            isSingleView={isSingleView}
                            page1StartColumn={grid.page1StartColumn}
                        />
                    </div>
                )}
            </div>
        </>
    );
}
